import Cashbill from './cashbill.route';
import KomisiBulanan from './komisi-bulanan.route';
import Jaringan from './jaringan.route';

let member = [];

member = member.concat(
    KomisiBulanan.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Statement Komisi'
        }
    })),
    Cashbill.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Cashbill'
        }
    })),
    Jaringan.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Jaringan'
        }
    }))
);

export default member;
